import admins from './admins/admins'
import main from './main/main'
import auth from './auth/auth'
import products from './products/products'
export default {
  admins,
  main,
  auth,
  products
}
